module.exports = __webpack_public_path__ + "img/moneypic.34032fed.svg";